import { getPhotographer, getAllMediasForPhotographer } from "../../../app/lib/prisma-db.js";

export async function getPhotographerFromID(id){
    const photographer = getPhotographer(id);

    return photographer;
}

export function getMediasFromID(id){
    const medias = getAllMediasForPhotographer(id);

    return medias;
}